import { ISection } from '../../../../../pages/services/[planSeoSlug]/p/components/page-sections/types';
import { usePlanCtx } from '../../../../../pages/services/[planSeoSlug]/p/planDetailsContext';
import { trackAction } from '../../../../utils';
import { scrollIntoView } from '../../navigation/utils';
import { navigationCtx } from '../context';
import { INavigatorVariant } from '../types';

export const VerticalSideNav: React.FC<INavigatorVariant> = ({
  className = '',
  scrollOffset = 0,
}) => {
  const { sections, activeSection, setActiveSectionCB, setJustScrolledCB } =
    navigationCtx();

  const planContext = usePlanCtx();

  const handleClick = (
    e: React.MouseEvent | React.TouchEvent,
    id: string,
    element: HTMLDivElement
  ) => {
    e.preventDefault();
    setJustScrolledCB(true);
    setActiveSectionCB(id);
    scrollIntoView(element, scrollOffset);
    trackAction('click', '', { label: `${id}_${planContext.seoSlug}` });
  };
  return (
    <nav className={className}>
      <ul>
        {sections.map((section) => {
          const sectionProps: ISection = section.props;
          const { id, name } = sectionProps;
          return (
            <li
              onClick={(e) => {
                handleClick(e, id, section.ref.current as HTMLDivElement);
              }}
              key={id}
              className={`text-s-14 cursor-pointer py-3 border-b-sm border-b-grey-300 ${
                id === activeSection
                  ? 'text-brand-700 underline font-bold'
                  : 'text-grey-700 font-medium'
              }`}
            >
              {name}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
